import React, { useContext } from "react";
import { Autocomplete, TextField } from "@mui/material";
import GroupBDRBiologists from "../FieldTags/GroupBDRBiologists";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";
const confPubs = [
    "AAAAI",
    "ATC",
    "Director's Meeting",
    "General Publication",
    "NSC",
];

const ConfPub = ({ confPub, handleChange, xplans }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);

    return (
        <div id="confPub" className="planField">
            <GroupBDRBiologists />
            <Autocomplete
                name="confPub"
                multiple
                freeSolo
                autoSelect
                options={confPubs}
                value={confPub ? confPub.split(",") : []}
                onChange={(_, newValue) => handleChange("confPub", newValue)}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        label={xplanLabels.confPub}
                        InputLabelProps={{ shrink: true }}
                    />
                }
                disabled={!canEdit}
            />
            {!newPlan && <HistoryLogElement xplans={xplans} label={"confPub"} />}
        </div>
    );
};

export default ConfPub;
